/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { MediaServicesOperationStatuses } from "../operationsInterfaces";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers";
import * as Parameters from "../models/parameters";
import { AzureMediaServices } from "../azureMediaServices";
import {
  MediaServicesOperationStatusesGetOptionalParams,
  MediaServicesOperationStatusesGetResponse
} from "../models";

/** Class containing MediaServicesOperationStatuses operations. */
export class MediaServicesOperationStatusesImpl
  implements MediaServicesOperationStatuses {
  private readonly client: AzureMediaServices;

  /**
   * Initialize a new instance of the class MediaServicesOperationStatuses class.
   * @param client Reference to the service client
   */
  constructor(client: AzureMediaServices) {
    this.client = client;
  }

  /**
   * Get media service operation status.
   * @param locationName Location name.
   * @param operationId Operation ID.
   * @param options The options parameters.
   */
  get(
    locationName: string,
    operationId: string,
    options?: MediaServicesOperationStatusesGetOptionalParams
  ): Promise<MediaServicesOperationStatusesGetResponse> {
    return this.client.sendOperationRequest(
      { locationName, operationId, options },
      getOperationSpec
    );
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const getOperationSpec: coreClient.OperationSpec = {
  path:
    "/subscriptions/{subscriptionId}/providers/Microsoft.Media/locations/{locationName}/mediaServicesOperationStatuses/{operationId}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.MediaServiceOperationStatus
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion1],
  urlParameters: [
    Parameters.$host,
    Parameters.subscriptionId,
    Parameters.locationName,
    Parameters.operationId
  ],
  headerParameters: [Parameters.accept],
  serializer
};
